import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import * as ACTIONS from './response-search.actions';
import { initialState } from './response-search.state';

const _responseSearchComponentContextReducers = createReducer(initialState,
  produceOn(ACTIONS.SET_TAG_SEARCH_TEXT, (state, props) => {
    const key = props.componentId;
    state.searchTexts[key] = props.text;
  }),

  produceOn(ACTIONS.CLEAR_ALL_TAG_SEARCH_TEXTS, (state, props) => {
    state.searchTexts = {};
  }),
);

export function responseSearchComponentContextReducers(state, action) {
  return _responseSearchComponentContextReducers(state, action);
}
